<template>
  <aside class="mb-20">
    <h2 class="h4 box-pad-5">Sua Reserva</h2>
    <ul class="border-blue box-list list-unstyled clearfix size-16 weight-lighter">
      <li class="box-list-item border-bottom">
        {{ 'Adulto' | pluralize(journey.adults) }}
        <span
          v-if="selectedPrice"
          class="pull-right weight-bold">
          {{ selectedPrice.base | brlPrice }}
        </span>
      </li>
      <li
        v-for="(tax, index) in computedTaxes"
        :key="`tax-${index}`"
        :class="[{ 'border-bottom': index < (computedTaxes.length - 1) }]"
        class="box-list-item clearfix">
        <template v-if="taxes.hasOwnProperty(tax.name)">
          {{ taxes[tax.name] }}
          <span class="pull-right weight-bold">{{ tax.value | brlPrice }}</span>
        </template>
        <template v-else>
          Taxa
          <span class="pull-right weight-bold">{{ tax.value | brlPrice }}</span>
        </template>
      </li>
    </ul>
    <span class="btn-gray btn-block btn-extra-large clearfix">
      <span class="pull-left">Total</span>
      <span class="pull-right">{{ selectedPrice.total | brlPrice }}</span>
    </span>
    <br>
  </aside>
</template>

<script>
export default {
  props: [
    'journey',
    'selectedPrice'
  ],
  data () {
    return {
      taxes: {
        'DU tax': 'Taxa de serviço',
        'Taxa DU': 'Taxa de serviço',
        'Taxes': 'Taxa de embarque',
        'Fee': 'Taxa de serviço',
        'Taxas': 'Taxa de embarque',
        'Taxa de embarque': 'Taxa de embarque'
      }
    }
  },
  computed: {
    computedTaxes () {
      return this.selectedPrice.taxes.filter(tax => (tax.value !== 0))
    }
  }
};
</script>
